import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {WSPIconName, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {area, mk} from '@mintdata/mint-kit/api/log/mk';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./WSPIcon.less');
const cx = classnames.bind(styles);

export interface IWSPIconExternalProps
{
    name:WSPIconName;
    className?:string;
    isBlock?:boolean;
    size?:WSPIconSize;
    intent?:MDIntent;
    SvgClass:React.ComponentClass<any>;
    onClick?:(e:React.SyntheticEvent<any>) => (void);
}

export class WSPIconExternal extends React.Component<IWSPIconExternalProps, any>
{
    render()
    {
        const {
            name,
            className,
            isBlock,
            size = WSPIconSize.medium,
            intent = MDIntent.Default,
            onClick,
            SvgClass
        } = this.props;

        const hasClassName = !!className;

        try
        {
            return (<SvgClass className={cx(styles.baseIcon,
                {intent: !hasClassName},
                className,
                {isBlock},
                size)} onClick={onClick}
            />);
        }
        catch( error )
        {
            mk.error(area.Icon, 'Could not find icon with name:', name);
            return null;
        }
    }
}
